@if (on === 'form' && control.field.condensed) {
    <div class="condensed">
        <div class="condensed-label">{{control.field.label}}</div>
        <div class="condensed-value">
            <span [attr.data-field]="control.field.name">{{control.value}}</span>
            <div class="condensed-hint">
                @if (control.field.hint) {
                    <mat-icon [matTooltip]="control.field.hint" matTooltipPosition="above">help</mat-icon>
                }
            </div>
        </div>
    </div>
}
@if (on === 'form' && !control.field.condensed) {
  <mat-form-field style="height: 74px">
    @if (control.field.hint) {
        <mat-icon matSuffix color="primary" [matTooltip]="control.field.hint">info</mat-icon>
    }
    <mat-label>{{control.field.label}}</mat-label>
    <input matInput [formControl]="control" [autocomplete]="control.field.autoComplete" 
    type="email" email id="{{control.field.name}}-emailField"
       [readonly]="control.field.readonly ? '' : null">
    <mat-error style="margin-top: -5px">
      <app-form-error [control]="control"></app-form-error>
    </mat-error>
  </mat-form-field>
}
@if (on === 'grid') {
    @if(control.field.readonly) {
        {{control.value}}
    } @else {
        <input matInput [formControl]="control" type="email" email
            [matTooltip]="control.getErrorMessage()"
            [attr.data-field-name]="control?.field?.name"
            [ngClass]="{'error': control.invalid && control.touched}"
            [autocomplete]="control.field.autoComplete"
            [readonly]="control.field.readonly ? '' : null">
    }
}
